import React from 'react';
import {Link} from 'react-router-dom';
import ongoing from '../static/pt_ongoing2.svg';
import complete from '../static/pt_complete2.svg';

export const TrainingTables = ({ptSessions}) =>{
  return(
    <div className="session_boxes">
      {ptSessions.map((session, i)=>(
        <div className={"session_box "+(session.is_done?"complete":"ongoing")}
          key={"session_box_"+i}>
          <div className="session_title">
            <span>Session {i+1}</span>
          </div>
          <div className="session_image">
            {session.is_done?
              <Link to={'/premium/personal-training/'+(i+1)}>
                <input className="pt_circle complete"
                type="image" src={complete} alt="complete" />
              </Link>:
              <Link to={'/premium/personal-training/'+(i+1)}>
                <input className="pt_circle ongoing"
                type="image" src={ongoing} alt="ongoing" />
              </Link>
            }
          </div>
        </div>
      ))}
    </div>
  );
};

export const EmptyPT = ({userState})=>{
  if(userState==='pro'){
    return(
      <div className="empty-pt">
        <span>トレーニングセッションがまだございません。</span>
      </div>
    )
  }else{
    return(
      <div className="empty-pt">
        <span>
          本機能はプレミアム会員専用の機能です。プレミアムにアップグレードしますと、より多くの学習機能がご利用できます。
        </span>
        <a className="btn-upgrade" href="http://edge.themusio.com/intro#section_p5">
          Premiumにアップグレード
        </a>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Pro.Training.Tables.js